import { LoadablePaint } from '@confluence/loadable';

export const TasksReportMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TasksReportMacro" */ '../src/TasksReportMacroRenderer.tsx'
			)
		).TasksReportMacroRenderer,
});
